import { Link, useParams } from "react-router-dom";
import NotFound from "./NotFound";
import { articlesByDate, findArticle } from "../articles";
import { useDocumentMeta } from "../lib/useDocumentMeta";
import { rolloutMode } from "../rollout";
import { toDocumentMeta, getRouteMeta } from "../route-meta";

export default function Article() {
  const { slug } = useParams();
  const article = slug ? findArticle(slug) : undefined;

  useDocumentMeta(
    article
      ? toDocumentMeta(getRouteMeta(`/articles/${article.meta.slug}`, rolloutMode)!)
      : { title: "Page not found", description: "Find the PX7 Training home page, method and articles." },
  );

  if (!article) return <NotFound />;

  const { Body, meta } = article;
  const related = articlesByDate.filter((a) => a.meta.slug !== meta.slug).slice(0, 2);

  return (
    <>
      <section className="mk-container pt-12 sm:pt-20 pb-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-[11px]">
            <Link to="/articles" className="text-px-text-muted hover:text-px-text">
              ← All articles
            </Link>
            <span className="text-px-text-muted">·</span>
            <span className="mk-eyebrow">{meta.eyebrow}</span>
            <span className="text-px-text-muted">·</span>
            <span className="text-px-text-muted">{meta.readMinutes} min read</span>
          </div>
          <h1 className="mk-h1 mt-4">{meta.title}</h1>
          <p className="mk-lead mt-4">{meta.description}</p>
          <p className="mt-5 text-[11px] text-px-text-muted">
            Published{" "}
            {new Date(meta.date).toLocaleDateString(undefined, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>
      </section>

      <article className="mk-container py-4">
        <div className="max-w-3xl mk-prose">
          <Body />
        </div>
      </article>

      <section className="mk-container py-10">
        <div className="max-w-3xl rounded-xl2 bg-px-green/10 border border-px-green/30 p-8 text-center">
          <h2 className="mk-h3">See how PX7 Training chooses the next run.</h2>
          <p className="mt-2 text-px-text-soft">
            We expect to launch on 1 November 2026. Receive news about PX7 Training and the method by email.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/#newsletter" className="mk-button-accent">Get the newsletter →</Link>
          </div>
        </div>
      </section>

      {related.length ? (
        <section className="mk-container pb-20">
          <div className="max-w-3xl">
            <p className="mk-eyebrow">Keep reading</p>
            <ul className="mt-4 grid gap-4 sm:grid-cols-2">
              {related.map((a) => (
                <li key={a.meta.slug}>
                  <Link
                    to={`/articles/${a.meta.slug}`}
                    className="block mk-card hover:border-px-green-dark/40 transition"
                  >
                    <div className="text-[10px] uppercase tracking-[0.2em] text-px-text-muted">
                      {a.meta.readMinutes} min read
                    </div>
                    <div className="mt-1 font-semibold">{a.meta.title} →</div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ) : null}
    </>
  );
}
